import { render, staticRenderFns } from "./select-years.vue?vue&type=template&id=b0fbb2fa"
import script from "./select-years.vue?vue&type=script&lang=js"
export * from "./select-years.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports